import componentsGuest from '../components-guest';
import { initApp, mountApp } from './common-guest';

const app = initApp();
componentsGuest(app);

mountApp(app);
